import {ValidationResultEnum} from "../../../types/validation-result.enum";
import {FlightSearchStepBase} from "./flight-search-step.base";
import {IOnBeforeActivationContext} from "../../../models/wizard/wizard.step.interface";
import {DialogResult} from "../../dialog/dialog-enums";
import {IPsoMarket} from "../../stations/pso-market.interface";
import {PsoUserOptionsEnum} from "../flight-search-controller/pso.enums";

export class FlightDatesSelectionStep extends FlightSearchStepBase {

    get title(): string {
        return this.services.language.translate('Dates');
    }

    get route() {
        return this.routes.flightDates;
    }

    async validate(): Promise<ValidationResultEnum> {
        return this.services.flightSearch.searchController.validateFlightDatesSelection();
    }

    private _psoMarketOnActivation: IPsoMarket | null = null;
    protected async _onBeforeActivation(context: IOnBeforeActivationContext): Promise<DialogResult> {
        if(context.routingGuardContext.isBackwardNavigation) {
            this._psoMarketOnActivation = null;
        } else {
            this._psoMarketOnActivation = await this.services.flightSearch.searchController.getPsoMarketAsync();
        }

        return await super._onBeforeActivation(context);
    }

    async next(): Promise<void> {
        if(ValidationResultEnum.Success !== await this.validate()) {
            return;
        }

        const searchController = this.services.flightSearch.searchController
        const psoMarket = await searchController.getPsoMarketAsync();
        if(psoMarket?.allowNewBookings
            && this._psoMarketOnActivation?.id !== psoMarket.id
            && searchController.psoUserOption === PsoUserOptionsEnum.None) {
            await this._showPsoConfirmationDialog(searchController, psoMarket, this.routes.passengers);
        } else {
            this._activateStepByRoute(this.routes.passengers);
        }
    }
}
